export enum ResultFlag {
  Normal = 1,
  Abnormal = 2,
  Acceptable = 4,
  Negative = 8,
  Positive = 16, // 0x00000010
  Critical = 32, // 0x00000020
  Alert = 64, // 0x00000040
  In = 128, // 0x00000080
  Out = 256, // 0x00000100
  None = 512, // 0x00000200
  Unacceptable = 1024, // 0x00000400
}

export enum ResultFlagNumeric
{
  LowCritical = 1,
  Low = 2,
  Normal = 4,
  High = 8,
  HighCritical = 16, // 0x00000010
  InconsistentData = 32, // 0x00000020
  Abnormal = 128, // 0x00000080
  None = 256, // 0x00000100
}

export class ResultFlagNumericConverter {
  public static convert(enumValue: ResultFlagNumeric) {
    switch (enumValue) {
      case ResultFlagNumeric.Abnormal: return "ABNORMAL";
      case ResultFlagNumeric.High: return "HIGH";
      case ResultFlagNumeric.HighCritical: return "HIGH CRITICAL";
      case ResultFlagNumeric.InconsistentData: return "INCONSISTENT";
      case ResultFlagNumeric.Low: return "LOW";
      case ResultFlagNumeric.LowCritical: return "LOW CRITICAL";
      case ResultFlagNumeric.Normal: return "NORMAL";
      case ResultFlagNumeric.None: return "NONE";
    }
  }
}
